<form class="entry-page-form" [formGroup]="form" (ngSubmit)="onSubmit(form)" novalidate>
    <h2 class="title" *ngIf="!isProfessionalForm">
        Please provide some additional information for your <span class="text-capitalize">{{ type }}</span> profile
    </h2>
    <ng-container *ngIf="isProfessionalForm">
        <h2 class="title">
            Please provide some additional information necessary for you to access your Certemy account
        </h2>

        <p class="entry-description">
            Please note that we use the Certemy platform to manage our certification and compliance programs. This is a
            separate platform that requires its own username (email) and password.
        </p>
    </ng-container>

    <div class="form-group" *ngFor="let i of fields">
        <label class="form-label">{{ i.label }}</label>
        <ng-container [ngSwitch]="i.type">
            <cm-select
                *ngSwitchCase="'select'"
                class="form-control inner-component"
                [options]="i.options"
                formControlName="{{ i.value }}"
                [ngClass]="{ 'is-invalid': showErrors && form.get(i.value).invalid }"
            >
            </cm-select>
            <input
                *ngSwitchDefault
                type="{{ i.type }}"
                [ngClass]="{ 'is-invalid': showErrors && form.get(i.value).invalid }"
                class="form-control"
                formControlName="{{ i.value }}"
            />
        </ng-container>
    </div>

    <cm-invite-location-block
        *ngIf="showLocationsForm"
        [form]="form"
        [locations]="locations"
        [showError]="showErrors"
        [profile]="profile"
        [organizationLabels]="organizationLabels"
    ></cm-invite-location-block>

    <div class="form-group">
        <input
            id="termCheckbox"
            class="ch-checkbox"
            type="checkbox"
            [checked]="terms_condition"
            (change)="terms_condition = !terms_condition"
        />
        <label for="termCheckbox" class="ch-checkbox-label">
            I accept <a class="cm-link" [routerLink]="['/terms-and-conditions']" target="_blank">Terms & Conditions</a>
        </label>
    </div>
    <div class="login-buttons"><button class="btn ch-button" type="submit" [disabled]="disabled">Continue</button></div>
    <cm-inline-error class="error-block mt-3" [errorMessages]="validationMessages" *ngIf="showErrors"></cm-inline-error>
</form>
